import { CardContainer } from '../CardContainer';
import { ApplicationContext } from '../../context/applicationContext';
import { OfferCardContextProvider } from '../OfferCardContextProvider';
import { IOfferCardWidgetProps } from '../../types';
import { ChatPopupContainer } from '../ChatPopupContainer';
import { NotAvailablePopupContainer } from '../NotAvailablePopupContainer';
import { ChatContextProvider } from '../ChatContextProvider';
import { NotAvailablePopupContextProvider } from '../NotAvailablePopupContextProvider';
import { FavoritesFoldersContainer } from '../FavoritesFoldersContainer';

export function OfferCardWidgetContainer({ context, onCardClick, ...cardProps }: IOfferCardWidgetProps) {
  return (
    <ApplicationContext.Provider value={context}>
      <OfferCardContextProvider {...cardProps}>
        <ChatContextProvider>
          <NotAvailablePopupContextProvider>
            <CardContainer onClick={onCardClick} />
            <ChatPopupContainer />
            <NotAvailablePopupContainer />
            <FavoritesFoldersContainer />
          </NotAvailablePopupContextProvider>
        </ChatContextProvider>
      </OfferCardContextProvider>
    </ApplicationContext.Provider>
  );
}
